"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dealerDetailsHours = _interopRequireDefault(require("./dealer-details-hours.css"));
var DepartmentHoursListItem = function DepartmentHoursListItem(_ref) {
  var hoursInfo = _ref.hoursInfo,
    theme = _ref.theme;
  return hoursInfo ? /*#__PURE__*/_react["default"].createElement("tr", {
    className: _dealerDetailsHours["default"].hoursListItem
  }, /*#__PURE__*/_react["default"].createElement("th", {
    className: theme ? theme.smallType : ''
  }, hoursInfo.dayOfTheWeek ? hoursInfo.dayOfTheWeek + " " : null), /*#__PURE__*/_react["default"].createElement("th", {
    className: theme ? theme.smallType : ''
  }, hoursInfo.openTime ? "" + hoursInfo.openTime : '')) : null;
};
DepartmentHoursListItem.defaultProps = {
  hoursInfo: {
    dayOfTheWeek: ''
  }
};
var _default = DepartmentHoursListItem;
exports["default"] = _default;